export default __webpack_public_path__ + "static/media/hht1_ani_19.fa019d83.png";